import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function CloudSupportAdvantages() {
  return (
    <section className='cloud-support-advantages tekrevol_gray_bg p-100'>
        <Container>
            <Row className='justify-content-center'>
            <Col
                 xs={12}
                 md={12}
                 lg={12}
                 xl={5}
                 xxl={6}
                
                >
                    <div className='main-title text-center'>
                        <h2>Why Choose TekRevol for Cloud Support </h2>
                    </div>
                    
                </Col>
            </Row>
            <Row className='justify-content-center'>
            <Col
                 xs={12}
                 md={12}
                 lg={12}
                 xl={4}
                 xxl={4}
                className='col-first d-flex flex-column justify-content-end'
                >
                    <Row>
                        <Col
                            xs={12}
                            md={6}
                            lg={6}
                            xl={12}
                            xxl={12}
                            className='col-first d-flex flex-column justify-content-end'
                        >
                            <div className='content content-two text-center'>
                                <span className='num num-two d-xl-none'>02</span>
                                <h3 className='title'>Niche experience</h3>
                                <p>So from healthcare to supply chain, we have taken our due time and invested keen training efforts to achieve the niche experience – the people, processes and policies we are incredibly proud of.</p>
                            </div>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            lg={6}
                            xl={12}
                            xxl={12}
                            className='col-first d-flex flex-column justify-content-end'
                        >
                            <div className='content content-one text-center'>
                                <span className='num num-one d-xl-none'>01</span>
                                <h3 className='title'>Strong cloud expertise</h3>
                                <p>We have a world-class team that is technically expert and certified to deploy, configure, and support clients in managing cloud environments. We have platform-specific expertise and align KPIs with best practices.</p>
                            </div>
                        </Col>
                    </Row>
                    
                </Col>
            <Col
                 xs={12}
                 md={6}
                 lg={6}
                 xl={4}
                 xxl={4}
                className='col-sec'
                >
                    <div className='content content-three text-center'>
                        <span className='num num-three d-xl-none'>03</span>
                        <h3 className='title'>Sustainability-first</h3>
                        <p>Sustainable cloud organizations are most welcoming to scalability, capacity multiplication and revenue growth. That’s why, we have teams that distinctively balance sustainable cloud setups with scalable strategies.</p>
                    </div>
                    <div className='image text-center d-xl-block d-none'>
                        <span className='num num-one d-xl-block d-none'>01</span>
                        <span className='num num-two d-xl-block d-none'>02</span>
                        <span className='num num-three d-xl-block d-none'>03</span>
                        <span className='num num-four d-xl-block d-none'>04</span>
                        <span className='num num-five d-xl-block d-none'>05</span>
                        <StaticImage
                            src="../../images/cloud-support-and-maintenance-services/advantages-image.webp"
                            alt="tekrevol_Partner"
                            className="img-fluid"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={484}
                            height={399}
                          />
                    </div>
                    
                </Col>
                <Col
                 xs={12}
                 md={12}
                 lg={12}
                 xl={4}
                 xxl={4}
                 className='col-third d-flex flex-column justify-content-end'
                
                >
                    <Row>
                        <Col
                            xs={12}
                            md={6}
                            lg={6}
                            xl={12}
                            xxl={12}
                            className='col-first d-flex flex-column justify-content-end'
                        >   
                            <div className='content content-four text-center'>
                                <span className='num num-four d-xl-none'>04</span>
                                <h3 className='title'>Objective-Oriented collaboration </h3>
                                <p>We are laser-focused on helping our new and retained clients achieve their business goals with cloud implementation and maintenance. Our support roadmaps are customized to accommodate your unique business needs.</p>
                            </div>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            lg={6}
                            xl={12}
                            xxl={12}
                            className='col-first d-flex flex-column justify-content-end'
                        >
                            <div className='content content-five text-center'>
                                <span className='num num-five d-xl-none'>05</span>
                                <h3 className='title'>Transparent reporting</h3>
                                <p>We are an experience-first company when it comes to customer success. We understand how transparency plays a solid role in your satisfaction and sound reporting is our action item to achieve 98% client retention rate we have bagged in 10 years. </p>
                            </div>
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default CloudSupportAdvantages